import { Component, OnInit } from '@angular/core';
import format from 'date-fns/format';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'pps-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  currentTime: string = null;
  isLoggedIn: boolean = false;
  appFullName: string = environment.appFullName;
  appName: string = environment.appName;
  private clockId: any = null;

  constructor(
    private _authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    // this._authService.ensureUserLoggedIn(()=>{
    //   console.log("From home page");
    //   this.isLoggedIn = true;
    //   this.startClock();
    // });
    this.isLoggedIn = true;
    this.startClock();
  }

  ngOnDestroy() {
    if (this.clockId) {
      clearInterval(this.clockId);
    }
  }
  
  private startClock(){
    this.currentTime = format(new Date(), "dd/MM/yyyy hh:mm:ss bbbb");
    
    this.clockId = setInterval(() => {
      this.currentTime = format(new Date(), "dd/MM/yyyy hh:mm:ss bbbb");
   }, 1000);
  }

  get userFullname(){
    return this._authService.userFullname;
  }

  get version(){
    return environment.version;
  }  
}
